// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svg-icon[data-v-616f0a5e]{width:1em;height:1em;vertical-align:-.15em;fill:currentColor;overflow:hidden}", ""]);
// Exports
module.exports = exports;
